export enum DistributorContractOption {
  LicenseGroup = 'LicenseGroup',
  SupplierContract = 'SupplierContract',
}
